import React from "react";
import WrapperRulesTable from "../../features/icwrapperrulestable";

const HouseRulesWrapperRulesPage = () => <WrapperRulesTable />

export default HouseRulesWrapperRulesPage;